import { __makeTemplateObject, __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import styled from 'styled-components';
import '../../node_modules/styled-system/dist/index.esm.js';
import '../../styles/young-icons.css.js';
import { compose } from '../../node_modules/@styled-system/core/dist/index.esm.js';
import { color } from '../../node_modules/@styled-system/color/dist/index.esm.js';
import { typography } from '../../node_modules/@styled-system/typography/dist/index.esm.js';
var IconStyled = styled.i(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), compose(color, typography));
IconStyled.defaultProps = {
  color: "inherit"
};
var Icon = function Icon(_a) {
  var icon = _a.icon,
    className = _a.className,
    rest = __rest(_a, ["icon", "className"]);
  return React__default.createElement(IconStyled, __assign({}, rest, {
    className: "icon-".concat(icon, " ").concat(className || "")
  }));
};
var templateObject_1;
export { Icon };